<div
  *ngIf="{
    eventTicket: selectedEventTicket$ | async,
    selectedStepIndex: selectedStepIndex$ | async
  } as obs"
  class="gb-event-ticket-guest-stepper"
>
  <mat-toolbar role="toolbar" class="gb-dialog-header">
    <h2 [translate]="config.title" mat-dialog-title></h2>
    <!-- mat-dialog-close result used in acceptance of ticket flow. If exiting at guest step, process should be cancelled. -->
    <button
      mat-icon-button
      [mat-dialog-close]="
        isGuestStep(obs.selectedStepIndex) ? EventTicketDialogResultEnum.Cancel : EventTicketDialogResultEnum.Success
      "
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <ng-container *ngIf="obs.eventTicket">
    <!-- [@.disabled]="true" to disable the mat-stepper animation as it glitchs on IOS -->
    <mat-stepper
      *ngIf="obs.eventTicket"
      [linear]="true"
      [selectedIndex]="obs.selectedStepIndex"
      (selectionChange)="onStepChange($event)"
      #stepper
      [@.disabled]="true"
      [class.hidden]="!shouldShowStepper(obs.eventTicket)"
    >
      <mat-step [label]="'SHARED.EVENT_TICKETS.STEPPER.ASSIGNEE_STEP_LABEL' | translate" [editable]="false">
        <ng-content></ng-content>
        <gb-event-ticket-guest-form
          [eventTicket]="obs.eventTicket"
          [shouldPrepopulateForm]="config.shouldPrepopulateForm ?? true"
          [shouldShowSelfAssign]="config.shouldShowSelfAssign ?? true"
          [canEditEmail]="config.canEditEmail"
          [buttonLabel]="config.buttonLabel"
          (formReady)="guestForm = $event"
          (onSelfAssignedChange)="isSelfAssigned = $event"
        >
          <ng-content select="[additionalFields]"> </ng-content>
        </gb-event-ticket-guest-form>
      </mat-step>
      <mat-step *ngIf="config.showDynamicStep" [label]="config.dynamicStepLabel || '' | translate" [editable]="false">
        <ng-template matStepContent>
          <ng-content select="[dynamicStep]"> </ng-content>
        </ng-template>
      </mat-step>
      <mat-step
        *ngIf="hasCustomFields(obs.eventTicket)"
        [label]="'SHARED.EVENT_TICKETS.STEPPER.QUESTIONS_STEP_LABEL' | translate"
        [editable]="false"
      >
        <gb-event-ticket-questions-form
          [customFields$]="selectedEventTicketCustomFields$"
          [customValues$]="selectedEventTicketCustomValues$"
          [shouldPrepopulateForm]="config.shouldPrepopulateForm"
          [allOptional]="!isSelfAssigned || isAdminOrVolunteer"
          (formReady)="questionsForm = $event"
        ></gb-event-ticket-questions-form>
      </mat-step>
    </mat-stepper>
    <mat-dialog-actions>
      <div class="actions-container">
        <div class="buttons-container">
          <button
            *ngIf="config.shouldShowCancelButton"
            mat-stroked-button
            [mat-dialog-close]="EventTicketDialogResultEnum.Cancel"
            type="button"
            translate="CANCEL"
          ></button>
          <button
            mat-raised-button
            color="primary"
            type="submit"
            (click)="onSubmit(obs.eventTicket, obs.selectedStepIndex)"
          >
            <span [translate]="getButtonLabel(obs.eventTicket, obs.selectedStepIndex)"></span>
          </button>
        </div>

        <div *ngIf="shouldShowSkipText(obs.selectedStepIndex)" class="skip-container">
          <span translate="SHARED.EVENT_TICKETS.STEPPER.SKIP_TEXT"> </span>
          <span
            *ngIf="config.emitOnStepSubmit; else submitOnFinalStep"
            class="primary-link"
            [translate]="config.skipLinkLabel!"
            [mat-dialog-close]="EventTicketDialogResultEnum.Success"
          >
          </span>

          <ng-template #submitOnFinalStep>
            <span
              class="primary-link"
              [translate]="config.skipLinkLabel!"
              (click)="onSubmit(obs.eventTicket, obs.selectedStepIndex)"
            >
            </span>
          </ng-template>
        </div>

        <ng-content select="[link]"> </ng-content>
      </div>
    </mat-dialog-actions>
  </ng-container>
</div>
